(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scarab-benefits-bar"] && !Shopify.designMode) return;
  try {
    
(function(){'use strict';function initCards(el){if(el._sbc)return;el._sbc=true;var track=el.querySelector('.sbc__track');var dots=Array.from(el.querySelectorAll('.sbc__dot'));var cards=Array.from(el.querySelectorAll('.sbc__card'));if(!track||!cards.length)return;var perPage=window.innerWidth>=750?parseInt(el.dataset.desktopCols,10)||5:3;var totalPages=Math.ceil(cards.length/perPage);function updateDots(page){dots.forEach(function(d,i){d.classList.toggle('is-active',i===page);});}var scrollTimer;track.addEventListener('scroll',function(){clearTimeout(scrollTimer);scrollTimer=setTimeout(function(){var cardW=cards[0]?cards[0].offsetWidth:1;var page=Math.round(track.scrollLeft/(cardW*perPage));updateDots(Math.min(page,totalPages-1));},80);},{passive:true});dots.forEach(function(dot,i){dot.addEventListener('click',function(){var cardW=cards[0]?cards[0].offsetWidth:0;track.scrollTo({left:cardW*perPage*i,behavior:'smooth'});updateDots(i);});});updateDots(0);}function init(){document.querySelectorAll('.sbc').forEach(initCards);}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}document.addEventListener('shopify:section:load',init);document.addEventListener('shopify:section:select',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scarab-hero-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  class ScarabHero {
    constructor(el){
      if(el._sh)return;el._sh=this;
      this.el=el;
      this.slides=Array.from(el.querySelectorAll('.scarab-hero__slide'));
      this.dots=Array.from(el.querySelectorAll('.scarab-hero__dot'));
      this.prevBtn=el.querySelector('.scarab-hero__arrow--prev');
      this.nextBtn=el.querySelector('.scarab-hero__arrow--next');
      this.bar=el.querySelector('.scarab-hero__progress-bar');
      this.current=0;this.total=this.slides.length;
      this.autoplay=el.dataset.autoplay==='true';
      this.speed=parseInt(el.dataset.speed,10)||5000;
      this.duration=parseInt(el.dataset.duration,10)||900;
      this.timer=null;this.busy=false;
      this._applyPositions();
      if(this.total===0)return;
      if(this.total===1)this._hideControls();
      this._bindEvents();
      if(this.autoplay&&this.total>1)this._startAuto();
    }
    _applyPositions(){
      this.slides.forEach(slide=>{
        const content=slide.querySelector('.scarab-hero__content');
        if(!content)return;
        const cs=getComputedStyle(slide);
        const read=(n,d)=>(cs.getPropertyValue(n).trim()||d);
        const map={desktop:{},mobile:{}};
        ['d','m'].forEach(p=>{
          const v=read('--'+p+'-valign','bottom');
          const h=read('--'+p+'-halign','left');
          const y=read('--'+p+'-y','0%');
          const x=read('--'+p+'-x','0%');
          const items=h==='center'?'center':(h==='right'?'flex-end':'flex-start');
          const text=h==='center'?'center':(h==='right'?'right':'left');
          slide.style.setProperty('--'+p+'-items',items);
          slide.style.setProperty('--'+p+'-text',text);
          map[p==='d'?'desktop':'mobile']={v,h,y,x};
        });
        this._positionContent(content,map);
      });
    }
    _positionContent(content,map){
      const apply=(cfg)=>{
        if(cfg.v==='top'){content.style.top=cfg.y;content.style.bottom='auto';}
        else if(cfg.v==='center'){content.style.top='50%';content.style.bottom='auto';}
        else {content.style.bottom=cfg.y;content.style.top='auto';}
        if(cfg.h==='center'){content.style.left='50%';content.style.right='auto';}
        else if(cfg.h==='right'){content.style.right=cfg.x;content.style.left='auto';}
        else {content.style.left=cfg.x;content.style.right='auto';}
        let tx='0',ty='0';
        if(cfg.h==='center')tx='-50%';
        if(cfg.v==='center')ty='-50%';
        content.style.transform='translate('+tx+','+ty+')';
      };
      const mq=window.matchMedia('(min-width: 750px)');
      const set=()=>apply(mq.matches?map.desktop:map.mobile);
      set();
      if(mq.addEventListener){mq.addEventListener('change',set);}else{mq.addListener(set);}
    }
    goTo(idx){
      if(this.busy||idx===this.current||this.total<2)return;
      this.busy=true;
      const prev=this.current;
      this.current=((idx%this.total)+this.total)%this.total;
      const out=this.slides[prev],inc=this.slides[this.current];
      out.classList.remove('is-active');out.classList.add('is-leaving');
      inc.classList.add('is-active');
      if(this.dots[prev]){this.dots[prev].classList.remove('is-active');this.dots[prev].setAttribute('aria-selected','false');}
      if(this.dots[this.current]){this.dots[this.current].classList.add('is-active');this.dots[this.current].setAttribute('aria-selected','true');}
      this._resetProgress();if(this.autoplay)this._startProgress();
      setTimeout(()=>{out.classList.remove('is-leaving');this.busy=false;},this.duration+120);
    }
    next(){this.goTo(this.current+1);}prev(){this.goTo(this.current-1);}
    _startAuto(){this._stopAuto();this._startProgress();this.timer=setInterval(()=>this.next(),this.speed);}
    _stopAuto(){clearInterval(this.timer);this.timer=null;this._resetProgress();}
    _startProgress(){if(!this.bar)return;this.bar.classList.remove('is-running');void this.bar.offsetWidth;this.bar.style.animationDuration=this.speed+'ms';this.bar.classList.add('is-running');}
    _resetProgress(){if(this.bar)this.bar.classList.remove('is-running');}
    _bindEvents(){
      this.prevBtn&&this.prevBtn.addEventListener('click',(e)=>{e.stopPropagation();this._stopAuto();this.prev();if(this.autoplay)this._startAuto();});
      this.nextBtn&&this.nextBtn.addEventListener('click',(e)=>{e.stopPropagation();this._stopAuto();this.next();if(this.autoplay)this._startAuto();});
      this.dots.forEach((dot,i)=>{dot.addEventListener('click',(e)=>{e.stopPropagation();this._stopAuto();this.goTo(i);if(this.autoplay)this._startAuto();});});
      let sx=0,sy=0;
      this.el.addEventListener('touchstart',(e)=>{sx=e.touches[0].clientX;sy=e.touches[0].clientY;},{passive:true});
      this.el.addEventListener('touchend',(e)=>{const dx=sx-e.changedTouches[0].clientX;const dy=sy-e.changedTouches[0].clientY;if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>44){this._stopAuto();dx>0?this.next():this.prev();if(this.autoplay)this._startAuto();}},{passive:true});
      this.el.setAttribute('tabindex','0');
      this.el.addEventListener('keydown',(e)=>{if(e.key==='ArrowLeft')this.prev();if(e.key==='ArrowRight')this.next();});
      this.el.addEventListener('mouseenter',()=>this._stopAuto());
      this.el.addEventListener('mouseleave',()=>{if(this.autoplay)this._startAuto();});
      document.addEventListener('visibilitychange',()=>{if(document.hidden)this._stopAuto();else if(this.autoplay)this._startAuto();});
    }
    _hideControls(){[this.prevBtn,this.nextBtn].forEach(btn=>btn&&btn.remove());const d=this.el.querySelector('.scarab-hero__dots');if(d)d.remove();const p=this.el.querySelector('.scarab-hero__progress');if(p)p.remove();}
  }
  function init(){document.querySelectorAll('.scarab-hero').forEach(el=>{el._sh=null;new ScarabHero(el);});}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:select',init);
  document.addEventListener('shopify:block:select',(e)=>{const hero=e.target.closest('.scarab-hero');if(!hero||!hero._sh)return;const idx=parseInt(e.target.dataset.slide,10);if(!isNaN(idx)){hero._sh._stopAuto();hero._sh.goTo(idx);}});
})();

  } catch(e) { console.error(e); }
})();
})();
